<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <!-- <notifications></notifications> -->
    <!-- <side-bar
      :sidebar-item-color="sidebarBackground"
      :sidebar-background-image="sidebarBackgroundImage"
    > -->
    <side-bar
      v-bind:class="[editorSidebar ? 'expandBar' : 'foldBar']"
      :style="backgroundColorStyle"
      idebar-item-color="sidebarBackground"
      :sidebar-background-image="sidebarBackgroundImage"
    >
      <mobile-menu slot="content"></mobile-menu>

      <div
        v-for="(item, index) in sideBarData"
        :key="index"
        class="ma-0 pa-0"
        style="display: flex; cursor: pointer"
        @click="changeRoute(index)"
      >
        <md-icon class="md-size-3x" :md-src="item.icon"></md-icon>
        <p
          v-if="editorSidebar"
          class="mt-5"
          style="font-size: 18px; font-family: Nunito Sans; color: white"
        >
          {{ item.name }}
        </p>
      </div>

      <!-- <div style="display: flex; cursor: pointer">
        <md-icon
          class="md-size-3x"
          md-src="/static/assets/svg/white/assetsThin.svg"
        ></md-icon>
        <p
          v-if="editorSidebar"
          class="mt-5"
          style="font-size: 18px; font-family: Nunito Sans; color: white"
        >
          Assets
        </p>
      </div> -->

      <!-- <div v-if="userType !== 'basic'" style="display: flex; cursor: pointer">
        <md-icon
          class="md-size-3x"
          md-src="/static/assets/svg/white/Dashboard.svg"
        ></md-icon>
        <p v-if="editorSidebar">Dashboard</p>
      </div> -->

      <!-- <div style="display: flex; cursor: pointer">
        <md-icon
          class="md-size-3x"
          md-src="/static/assets/svg/white/viewerThin.svg"
        ></md-icon>
        <p
          v-if="editorSidebar"
          class="mt-5"
          style="font-size: 18px; font-family: Nunito Sans; color: white"
        >
          Viewer
        </p>
      </div>

      <div style="display: flex; cursor: pointer">
        <md-icon
          class="md-size-3x"
          md-src="/static/assets/svg/white/editorThick.svg"
        ></md-icon>
        <p
          v-if="editorSidebar"
          class="mt-5"
          style="font-size: 18px; font-family: Nunito Sans; color: white"
        >
          Editor
        </p>
      </div> -->

      <div
        v-if="editorSidebar"
        style="position: absolute; left: 20px; bottom: 120px"
      >
        <div
          style="display: flex; margin-left: 5px !important; cursor: pointer"
          class="ma-0 pa-0"
          @click="seeAction()"
        >
          <v-btn icon>
            <!-- <md-icon
              class="md-size-2x"
              md-src="/static/assets/svg/editorOpen.svg"
            ></md-icon> -->
            <v-icon style="font-size: 30px !important">mdi-menu-open</v-icon>
          </v-btn>
          <p
            class="mt-2"
            style="font-size: 13px; font-family: Nunito Sans; color: white"
          >
            Inspector
          </p>
        </div>
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <div
              v-on="on"
              style="
                display: flex;

                cursor: pointer;
              "
              class="ma-0 pa-0"
            >
              <v-btn icon>
                <md-icon
                  class="md-size-1x"
                  md-src="/static/assets/svg/white/Remesh_24px.svg"
                ></md-icon>
              </v-btn>
              <p
                class="mt-2"
                style="font-size: 13px; font-family: Nunito Sans; color: white"
              >
                Remesh
              </p>
            </div>
          </template>
          <span>Beta 1.2</span>
        </v-tooltip>
        <div
          style="
            display: flex;

            cursor: pointer;
          "
          class="ma-0 pa-0"
          @click="addVersionRoute()"
        >
          <v-btn icon>
            <md-icon
              class="md-size-1x"
              md-src="/static/assets/svg/white/Add3DVersion.svg"
            ></md-icon>
          </v-btn>
          <p
            class="mt-2"
            style="font-size: 13px; font-family: Nunito Sans; color: white"
          >
            Add New Version
          </p>
        </div>
        <div
          style="
            display: flex;

            cursor: pointer;
          "
          class="ma-0 pa-0"
          @click="addFileRoute()"
        >
          <v-btn icon>
            <md-icon
              class="md-size-1x"
              md-src="/static/assets/svg/white/Add3DAsset.svg"
            ></md-icon>
          </v-btn>
          <p
            class="mt-2"
            style="font-size: 13px; font-family: Nunito Sans; color: white"
          >
            Add New Asset
          </p>
        </div>
      </div>

      <div
        v-if="editorSidebar"
        style="display: flex; position: absolute; left: 20px; bottom: 3%"
        class="ma-0 pa-0"
      >
        <div class="ma-0 pa-0">
          <v-menu
            ref="menu1"
            rounded="lg"
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            top
            offset-y
            max-width="170"
          >
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" elevation="0" style="box-shadow: none"
                ><v-icon>mdi-tune</v-icon></v-btn
              >
            </template>
            <v-card
              class="ma-0 pa-0"
              rounded="lg"
              width="175"
              height="300"
              :style="{
                background: $vuetify.theme.themes[theme].background,
              }"
            >
              <div class="pl-7 pt-4 ma-0">
                <p class="display-22"><strong>Customize UI</strong></p>
                <p class="caption-11">Highlight Color</p>
                <v-avatar
                  class="mr-3 mt-n2"
                  style="cursor: pointer"
                  v-for="(item, index) in itemscolor"
                  :key="index"
                  :color="item.color"
                  @click="colorff(item)"
                  size="19"
                ></v-avatar>
                <p class="caption-11 mt-2">Sidebar Color</p>
                <v-avatar
                  class="mr-3 mt-n2"
                  v-for="(item, index) in itemsbackcolor"
                  :key="index"
                  :color="item.color"
                  @click="colorf(item)"
                  style="cursor: pointer"
                  size="19"
                ></v-avatar>
                <p class="caption-11 mt-2">Icon Size</p>
                <v-row class="ma-0 pa-0 ml-n3 mt-n3 mr-3">
                  <v-btn icon class="pt-1"
                    ><v-icon size="17">mdi-square</v-icon></v-btn
                  >
                  <v-slider
                    class="ma-0 pa-0 mt-1"
                    v-model="iconRowSize"
                    size="30"
                    max="150"
                    min="70"
                    track-color="grey"
                    track-fill-color="grey"
                  ></v-slider>
                  <v-btn icon
                    ><v-icon size="30"
                      >mdi-checkbox-blank-outline</v-icon
                    ></v-btn
                  >
                </v-row>
                <p
                  class="display-22 mt-n3"
                  style="color: #6699cc; font-weight: 900; letter-spacing: 2px"
                >
                  <strong
                    v-if="augmentableTheme"
                    @click="changeTheme()"
                    style="cursor: pointer"
                    >BRIGHTMODE</strong
                  >
                  <strong
                    v-if="!augmentableTheme"
                    @click="changeTheme()"
                    style="cursor: pointer"
                    >DARKMODE</strong
                  >
                </p>
              </div>
            </v-card>
          </v-menu>
        </div>
        <div class="ma-0 pa-0 mt-n1">
          <v-btn @click="changeTheme()" icon
            ><md-icon
              v-if="augmentableTheme"
              class="md-size-1x"
              md-src="/static/assets/svg/white/sun.svg"
            ></md-icon
            ><md-icon
              v-if="!augmentableTheme"
              class="md-size-1x"
              md-src="/static/assets/svg/white/moon.svg"
            ></md-icon>
          </v-btn>
        </div>
        <!-- <div class="ma-0 pa-0 pt-1">
          <p style="color: #1976d2; cursor: pointer" @click="addFileRoute()">
            Add new asset
          </p>
        </div> -->
        <div class="ma-0 pa-0 mt-n1">
          <v-menu
            rounded="xl"
            :close-on-content-click="false"
            transition="scale-transition"
            top
            offset-y
            max-width="200"
          >
            <template v-slot:activator="{ on }">
              <div style="display: flex; justify-content: center" v-on="on">
                <v-btn icon>
                  <md-icon
                    class="md-size-1x"
                    md-src="/static/assets/svg/white/Manager.svg"
                  >
                  </md-icon>
                  <!-- <md-icon
                    v-if="!augmentableTheme"
                    class="md-size-2x"
                    md-src="/static/assets/svg/black/Manager.svg"
                  >
                  </md-icon> -->
                </v-btn>
              </div>
            </template>
            <v-card
              class="ma-0 pa-0"
              width="200"
              height="225"
              rounded="xl"
              :style="{ background: $vuetify.theme.themes[theme].background }"
              ><div class="pl-7 pr-7 pt-4 ma-0">
                <p class="display-22"><strong>Profile Settings</strong></p>

                <div class="ma-0 pa-0" style="display: flex">
                  <div class="ma-0 pa-0">
                    <v-btn
                      class="ma-0 pa-0 ml-n2 mt-n1"
                      icon
                      @click="userProfile()"
                    >
                      <v-icon>mdi-account-outline</v-icon>
                    </v-btn>
                  </div>
                  <div class="ma-0 pa-0 mt-1">
                    <p
                      class="caption-11"
                      style="cursor: pointer"
                      @click="userProfile()"
                    >
                      User Profile
                    </p>
                  </div>
                </div>
                <v-divider
                  class="pl-5 pr-5 mt-n3"
                  style="border-color: #d3d3d3"
                ></v-divider>
                <div class="ma-0 pa-0" style="display: flex">
                  <div class="ma-0 pa-0">
                    <v-btn class="ma-0 pa-0 ml-n2 mt-n1" icon>
                      <v-icon>mdi-bell-alert-outline</v-icon>
                    </v-btn>
                  </div>
                  <div class="ma-0 pa-0 mt-1">
                    <p class="caption-11" style="cursor: pointer">
                      Notifications
                    </p>
                  </div>
                </div>

                <v-divider
                  class="pl-5 pr-5 mt-n3"
                  style="border-color: #d3d3d3"
                ></v-divider>
                <div class="ma-0 pa-0" style="display: flex">
                  <div class="ma-0 pa-0">
                    <v-btn class="ma-0 pa-0 ml-n2 mt-n1" icon>
                      <v-icon>mdi-upload</v-icon>
                    </v-btn>
                  </div>
                  <div class="ma-0 pa-0 mt-1">
                    <p class="caption-11" style="cursor: pointer">
                      Upgrade License
                    </p>
                  </div>
                </div>
                <v-divider
                  class="pl-5 pr-5 mt-n3"
                  style="border-color: #d3d3d3"
                ></v-divider>
                <div class="ma-0 pa-0" style="display: flex">
                  <div class="ma-0 pa-0">
                    <v-btn class="ma-0 pa-0 ml-n2 mt-n1" icon>
                      <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                  </div>
                  <div class="ma-0 pa-0 mt-1">
                    <p class="caption-11" style="cursor: pointer">Help</p>
                  </div>
                </div>
                <v-divider
                  class="pl-5 pr-5 mt-n3"
                  style="border-color: #d3d3d3"
                ></v-divider>
                <div class="ma-0 pa-0" style="display: flex">
                  <div class="ma-0 pa-0">
                    <v-btn
                      class="ma-0 pa-0 ml-n2 mt-n1"
                      icon
                      @click="userLogout()"
                    >
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </div>
                  <div class="ma-0 pa-0 mt-1">
                    <p
                      class="caption-11"
                      style="cursor: pointer"
                      @click="userLogout()"
                    >
                      Log Out
                    </p>
                  </div>
                </div>
                <v-divider
                  class="pl-5 pr-5 mt-n3"
                  style="border-color: #d3d3d3"
                ></v-divider>
              </div>
            </v-card>
          </v-menu>
        </div>
      </div>
      <div
        v-if="!editorSidebar"
        style="position: absolute; left: 15px; bottom: 12%"
      >
        <div class="ma-0 pa-0 ml-3 mt-1">
          <v-btn icon @click="seeAction()">
            <!-- <md-icon
              class="md-size-2x"
              md-src="/static/assets/svg/editorOpen.svg"
            ></md-icon> -->
            <v-icon style="font-size: 30px !important">mdi-menu-open</v-icon>
          </v-btn>
        </div>
        <div class="ma-0 pa-0 ml-2">
          <v-btn icon>
            <md-icon
              class="md-size-1x"
              md-src="/static/assets/svg/white/Remesh_24px.svg"
            ></md-icon>
          </v-btn>
        </div>
        <div class="ma-0 pa-0 ml-2 mt-1">
          <v-btn icon @click="addVersionRoute()">
            <md-icon
              class="md-size-1x"
              md-src="/static/assets/svg/white/Add3DVersion.svg"
            ></md-icon>
          </v-btn>
        </div>
        <div class="ma-0 pa-0 ml-2 mt-1">
          <v-btn icon @click="addFileRoute()">
            <md-icon
              class="md-size-1x"
              md-src="/static/assets/svg/white/Add3DAsset.svg"
            ></md-icon>
          </v-btn>
        </div>
        <div class="ma-0 pa-0 ml-n1">
          <v-menu
            rounded="lg"
            :close-on-content-click="false"
            transition="scale-transition"
            top
            offset-y
            max-width="200"
          >
            <template v-slot:activator="{ on }">
              <div style="display: flex; justify-content: center" v-on="on">
                <v-btn icon>
                  <md-icon
                    class="md-size-1x"
                    md-src="/static/assets/svg/white/Manager.svg"
                  >
                  </md-icon>
                  <!-- <md-icon
                    v-if="!augmentableTheme"
                    class="md-size-2x"
                    md-src="/static/assets/svg/black/Manager.svg"
                  >
                  </md-icon> -->
                </v-btn>
              </div>
            </template>
            <v-card
              class="ma-0 pa-0"
              width="200"
              height="225"
              rounded="lg"
              :style="{ background: $vuetify.theme.themes[theme].background }"
              ><div class="pl-7 pr-7 pt-4 ma-0">
                <p class="display-22"><strong>Profile Settings</strong></p>

                <div class="ma-0 pa-0" style="display: flex">
                  <div class="ma-0 pa-0">
                    <v-btn
                      class="ma-0 pa-0 ml-n2 mt-n1"
                      icon
                      @click="userProfile()"
                    >
                      <v-icon>mdi-account-outline</v-icon>
                    </v-btn>
                  </div>
                  <div class="ma-0 pa-0 mt-1">
                    <p
                      class="caption-11"
                      style="cursor: pointer"
                      @click="userProfile()"
                    >
                      User Profile
                    </p>
                  </div>
                </div>
                <v-divider
                  class="pl-5 pr-5 mt-n3"
                  style="border-color: #d3d3d3"
                ></v-divider>
                <div class="ma-0 pa-0" style="display: flex">
                  <div class="ma-0 pa-0">
                    <v-btn class="ma-0 pa-0 ml-n2 mt-n1" icon>
                      <v-icon>mdi-bell-alert-outline</v-icon>
                    </v-btn>
                  </div>
                  <div class="ma-0 pa-0 mt-1">
                    <p class="caption-11" style="cursor: pointer">
                      Notifications
                    </p>
                  </div>
                </div>

                <v-divider
                  class="pl-5 pr-5 mt-n3"
                  style="border-color: #d3d3d3"
                ></v-divider>
                <div class="ma-0 pa-0" style="display: flex">
                  <div class="ma-0 pa-0">
                    <v-btn class="ma-0 pa-0 ml-n2 mt-n1" icon>
                      <v-icon>mdi-upload</v-icon>
                    </v-btn>
                  </div>
                  <div class="ma-0 pa-0 mt-1">
                    <p class="caption-11" style="cursor: pointer">
                      Upgrade License
                    </p>
                  </div>
                </div>
                <v-divider
                  class="pl-5 pr-5 mt-n3"
                  style="border-color: #d3d3d3"
                ></v-divider>
                <div class="ma-0 pa-0" style="display: flex">
                  <div class="ma-0 pa-0">
                    <v-btn class="ma-0 pa-0 ml-n2 mt-n1" icon>
                      <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                  </div>
                  <div class="ma-0 pa-0 mt-1">
                    <p class="caption-11" style="cursor: pointer">Help</p>
                  </div>
                </div>
                <v-divider
                  class="pl-5 pr-5 mt-n3"
                  style="border-color: #d3d3d3"
                ></v-divider>
                <div class="ma-0 pa-0" style="display: flex">
                  <div class="ma-0 pa-0">
                    <v-btn
                      class="ma-0 pa-0 ml-n2 mt-n1"
                      icon
                      @click="userLogout()"
                    >
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </div>
                  <div class="ma-0 pa-0 mt-1">
                    <p
                      class="caption-11"
                      style="cursor: pointer"
                      @click="userLogout()"
                    >
                      Log Out
                    </p>
                  </div>
                </div>
                <v-divider
                  class="pl-5 pr-5 mt-n3"
                  style="border-color: #d3d3d3"
                ></v-divider>
              </div>
            </v-card>
          </v-menu>
        </div>

        <div class="ma-0 pa-0 ml-2">
          <v-btn @click="changeTheme()" icon
            ><md-icon
              v-if="augmentableTheme"
              class="md-size-1x"
              md-src="/static/assets/svg/white/sun.svg"
            ></md-icon
            ><md-icon
              v-if="!augmentableTheme"
              class="md-size-1x"
              md-src="/static/assets/svg/white/moon.svg"
            ></md-icon>
          </v-btn>
        </div>
        <div class="ma-0 pa-0 ml-1">
          <v-menu
            rounded="lg"
            :close-on-content-click="false"
            transition="scale-transition"
            top
            offset-y
            max-width="170"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                x-large
                icon
                v-on="on"
                elevation="0"
                style="box-shadow: none"
                ><v-icon style="font-size: 27px !important"
                  >mdi-tune</v-icon
                ></v-btn
              >
            </template>
            <v-card
              class="ma-0 pa-0"
              rounded="lg"
              width="175"
              height="300"
              :style="{
                background: $vuetify.theme.themes[theme].background,
              }"
            >
              <div class="pl-7 pt-4 ma-0">
                <p class="display-22"><strong>Customize UI</strong></p>
                <p class="caption-11">Highlight Color</p>
                <v-avatar
                  class="mr-3 mt-n2"
                  style="cursor: pointer"
                  v-for="(item, index) in itemscolor"
                  :key="index"
                  :color="item.color"
                  @click="colorff(item)"
                  size="19"
                ></v-avatar>
                <p class="caption-11 mt-2">Sidebar Color</p>
                <v-avatar
                  class="mr-3 mt-n2"
                  v-for="(item, index) in itemsbackcolor"
                  :key="index"
                  :color="item.color"
                  @click="colorf(item)"
                  style="cursor: pointer"
                  size="19"
                ></v-avatar>
                <p class="caption-11 mt-2">Icon Size</p>
                <v-row class="ma-0 pa-0 ml-n3 mt-n3 mr-3">
                  <v-btn icon class="pt-1"
                    ><v-icon size="17">mdi-square</v-icon></v-btn
                  >
                  <v-slider
                    class="ma-0 pa-0 mt-1"
                    v-model="iconRowSize"
                    size="30"
                    max="150"
                    min="70"
                    track-color="grey"
                    track-fill-color="grey"
                  ></v-slider>
                  <v-btn icon
                    ><v-icon size="30"
                      >mdi-checkbox-blank-outline</v-icon
                    ></v-btn
                  >
                </v-row>
                <p
                  class="display-22 mt-n3"
                  style="color: #6699cc; font-weight: 900; letter-spacing: 2px"
                >
                  <strong
                    v-if="augmentableTheme"
                    @click="changeTheme()"
                    style="cursor: pointer"
                    >BRIGHTMODE</strong
                  >
                  <strong
                    v-if="!augmentableTheme"
                    @click="changeTheme()"
                    style="cursor: pointer"
                    >DARKMODE</strong
                  >
                </p>
              </div>
            </v-card>
          </v-menu>
        </div>
      </div>
    </side-bar>

    <div
      class="main-panel"
      v-bind:class="[editorSidebar ? 'foldEditor' : 'expandEditor']"
    >
      <top-navbar
        style="position: fixed; top: 0; right: 0; width: auto"
      ></top-navbar>

      <!--
      <fixed-plugin
        :color.sync="sidebarBackground"
        :image.sync="sidebarBackgroundImage"
      ></fixed-plugin>
      -->

      <dashboard-content></dashboard-content>
      <!--<dashboard-core-settings /> -->

      <!--<content-footer v-if="!$route.meta.hideFooter"></content-footer>-->
    </div>
  </div>
</template>

<script>
import TopNavbar from "./TopNavbar.vue";
//import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu.vue";
//import FixedPlugin from "./Extra/FixedPlugin.vue";

import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

import store from "../../store";
import { mapState } from "vuex";

//import "../../assets/scss/material-dashboard.scss";

import * as BabylonViewer from "@babylonjs/viewer";
import { GLTF2Export } from "@babylonjs/serializers/glTF";
import * as BABYLON from "@babylonjs/core";

import "@babylonjs/loaders/glTF";

import { Tools } from "@babylonjs/core/Misc";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    //ContentFooter,
    MobileMenu,
    //FixedPlugin,

    //DashboardCoreSettings: () =>
    //import("../../views/dashboard/components/core/Settings"),
  },
  data() {
    return {
      sidebarBackground: "green",
      sidebarBackgroundImage: "blue",
      bgColor: "grey",

      itemscolor: [
        { color: "yellow" },
        { color: "blue" },
        { color: "red" },
        { color: "pink" },
      ],
      itemsbackcolor: [
        { color: "#d0d0d0" },
        { color: "#000000" },
        { color: "#404040" },
      ],
      userInfo: {
        id: "",
        username: "",
        email: "",
        first_name: "",
        last_name: "",
      },
      userType: "basic",

      sideBarData: [
        {
          name: "Assets",
          icon: "/static/assets/svg/white/assetsThin.svg",
          checked: true,
        },
        {
          name: "Viewer",
          icon: "/static/assets/svg/white/viewerThin.svg",
          checked: false,
        },
        {
          name: "Editor",
          icon: "/static/assets/svg/white/editorThick.svg",
          checked: false,
        },
      ],
    };
  },

  computed: {
    ...mapState(["augmentableTheme"]),
    ...mapState(["editorSidebar"]),
    backgroundColorStyle() {
      return {
        "background-color": this.bgColor,
      };
    },

    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },

    iconRowSize: {
      get() {
        return store.state.iconrowSize;
      },
      set(val) {
        this.$store.commit("setIconRowSize", val);
      },
    },
  },
  mounted() {
    if (this.augmentableTheme === true) {
      this.darkTheme = true;
      this.colorTheme = "#d3d3d3";
    } else {
      this.lightTheme = true;
      this.colorTheme = "black";
    }

    this.userType = store.state.userType;
    // axios
    //   .get("/dj-rest-auth/user/", {
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization:
    //         "Token " + this.getAuthCookie("augmentableUserToken") + "",
    //     },
    //   })
    //   .then((response) => {
    //     this.userInfo.id = response.data.pk;
    //     this.userInfo.username = response.data.username;
    //     this.userInfo.email = response.data.email;
    //     this.userInfo.first_name = response.data.first_name;
    //     this.userInfo.last_name = response.data.last_name;

    //     axios
    //       .get(
    //         "/api/users1/userInfooID/" +
    //           this.userInfo.id +
    //           "/"
    //       )
    //       .then((response) => {
    //         // console.log(response);
    //         // console.log(response.data);
    //         this.userType = response.data.user_type;
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //       });
    //   })
    //   .catch((response) => {
    //     //console.log("user information22");
    //     console.log(response);
    //     //console.log(response.data);
    //   });
  },
  methods: {
    changeTheme() {
      if (this.augmentableTheme === true) {
        this.$store.commit("setAugmentableTheme", false);
        this.$vuetify.theme.dark = false;
      } else if (this.augmentableTheme === false) {
        this.$store.commit("setAugmentableTheme", true);
        this.$vuetify.theme.dark = true;
      }
    },
    colorf(x) {
      this.bgColor = x.color;
    },
    addfile() {
      this.$router.push({ path: "/addFile" });
    },

    changeRoute(x) {
      if (x === 0) {
        this.$router.push({ path: "/assets" });
      } else if (x === 1) {
        this.$router.push({ path: "/viewer" });
      } else if (x === 2) {
        return;
      }
    },
    async addFileRoute() {
      this.overlayP = true;
      var router = this.$router;

      BabylonViewer.viewerManager
        .getViewerPromiseById("loading-demo")
        .then(function (viewer) {
          viewer.sceneManager.scene.clearColor = new BABYLON.Color4(
            0,
            0,
            0,
            0.0000000000000001
          );

          GLTF2Export.GLBAsync(viewer.sceneManager.scene, "scene").then(
            (glb) => {
              console.log(glb.glTFFiles["scene.glb"]);
              var file = new File([glb.glTFFiles["scene.glb"]], "export.glb");
              //console.log(file);
              var batch = true;
              router.push({
                name: "Add Asset",
                params: { batchFile: file, batch: batch },
              });
            }
          );
        });
    },

    seeAction() {
      this.editorDiv = !this.editorDiv;
      if (this.editorDiv === true) {
        BabylonViewer.viewerManager
          .getViewerPromiseById("loading-demo")
          .then(function (viewer) {
            // this will resolve only after the viewer with this specific ID is initialized
            //console.log("Using promises: ", "viewer - " + viewer.getBaseId());
            //viewer.sceneManager.scene.debugLayer.show();

            viewer.sceneManager.scene.debugLayer.show({
              overlay: false,
              globalRoot: document.getElementById("inspectorDiv"),
              embedMode: true,
            });
          });
      } else {
        BabylonViewer.viewerManager
          .getViewerPromiseById("loading-demo")
          .then(function (viewer) {
            // this will resolve only after the viewer with this specific ID is initialized
            viewer.sceneManager.scene.debugLayer.hide();
          });
      }

      //BABYLON.Sandbox.Show({hostElement: document.getElementById("hhgg")});
    },

    async addVersionRoute() {
      var fileDetail = store.state.fileDetail;
      if (fileDetail.filename) {
        this.overlayP = true;
        var router = this.$router;
        var abServerPath = this.$abServerPath;

        var selectedFileVersion = fileDetail.filename;

        var authToken = this.getAuthCookie("augmentableUserToken");

        let formData = new FormData();

        formData.append("filename", fileDetail.filename);
        formData.append("filetype", "GLB");

        formData.append("description", "");
        formData.append("state", "unProcessed");
        formData.append("tags", "");
        formData.append("linkHDR", "");

        var tt = fileDetail.filename + ".glb";

        BabylonViewer.viewerManager
          .getViewerPromiseById("loading-demo")
          .then(function (viewer) {
            //to make the scene transparent
            viewer.sceneManager.scene.clearColor = new BABYLON.Color4(
              0,
              0,
              0,
              0.0000000000000001
            );

            let activeCamera = viewer.sceneManager.scene.activeCamera;

            if (activeCamera) {
              Tools.CreateScreenshotUsingRenderTarget(
                viewer.sceneManager.scene.getEngine(),
                activeCamera,
                { width: 490, height: 490 },
                function (data) {
                  var byteString;
                  if (data.split(",")[0].indexOf("base64") >= 0)
                    byteString = atob(data.split(",")[1]);
                  else byteString = unescape(data.split(",")[1]);

                  // separate out the mime component
                  var mimeString = data
                    .split(",")[0]
                    .split(":")[1]
                    .split(";")[0];

                  // write the bytes of the string to a typed array
                  var ia = new Uint8Array(byteString.length);
                  for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                  }

                  var blob = new Blob([ia], { type: mimeString });

                  formData.append(
                    "filepng",
                    blob,
                    selectedFileVersion + ".png"
                  );
                }
              );
            }

            GLTF2Export.GLBAsync(viewer.sceneManager.scene, "scene").then(
              (glb) => {
                console.log(glb.glTFFiles["scene.glb"]);
                var file = new File([glb.glTFFiles["scene.glb"]], "export.glb");

                formData.append("fileglb", file, tt);
                console.log(file);
                //console.log("" + (file.size / (1024 * 1024)).toFixed(2) + "MB");
                var filesize =
                  "" + (file.size / (1024 * 1024)).toFixed(2) + "MB";
                formData.append("filesize", filesize);

                axios
                  .post(
                    abServerPath +
                      "/api/glbfiles/glbpostfileversion/" +
                      selectedFileVersion +
                      "/",
                    formData,
                    {
                      headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: "Token " + authToken + "",
                      },
                    }
                  )
                  .then((response) => {
                    router.push({
                      name: "File Detail",
                      params: { slug: store.state.fileDetail.slug },
                    });
                    console.log(response.data);
                    console.log("SUCCESS!!");
                  })
                  .catch((error) => {
                    router.push({
                      name: "File Detail",
                      params: { slug: store.state.fileDetail.slug },
                    });
                    console.log(error.data);
                    console.log("ffff");
                  });
              }
            );
          });
      }
    },
    getAuthCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    userProfile() {
      if (store.state.userType === "basic") {
        this.$router.push({ path: "/assets" });
      } else {
        this.$router.push({ path: "/user_profile" });
      }
    },
    userLogout() {
      this.$store.commit("setAuthentication", false);
      //expiring cookie and delete
      document.cookie =
        "augmentableUserToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      this.$router.push({ name: "account" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/material-dashboard.scss";
.hoverIcon {
  stroke: white;
}
.hoverIcon:hover {
  stroke-linejoin: miter;
  stroke-width: 1em;
  stroke: white;
}

.expandBar {
  width: 180px !important;
}
.foldEditor {
  width: calc(100% - 180px);
}

.foldBar {
  width: 75px !important;
}
.expandEditor {
  width: calc(100% - 75px);
}
</style>
